// The base game view's background art width ON SCREEN (px), published by
// GameViewSimpleController.coverBackground after every placement. The bottom
// bar never runs past it (useSecondaryToolbar) — "UI must not exceed the game
// view's width" (Vladimir, 2026-10-22). 0 until the room has measured.
let width = 0;
const listeners = new Set();

export const publishGameViewArtWidth = (px) => {
  const next = Math.round(px) || 0;
  if (Math.abs(next - width) < 1) return;
  width = next;
  listeners.forEach((fn) => fn());
};

export const getGameViewArtWidth = () => width;

export const subscribeGameViewArtWidth = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
